import ActionButton from '@/common/components/buttons/ActionButton';
import Loading from '@/common/components/Loading';
import { PageWrapper } from '@/common/styles/Wrappers';
import { ContentWrapper } from './Attachments.styled';
import AttachmentForm from './components/attachmentForm/AttachmentForm';
import AttachmentsTable from './components/AttachmentsTable';
import useAttachments from './useAttachments';

const Attachments = () => {
	const hook = useAttachments();

	return (
		<PageWrapper>
			{hook.isLoading && <Loading />}
			<ContentWrapper>
				<ActionButton
					defaultText='Add file'
					onClick={() => {
						hook.setSelectedFile(null);
						hook.setShow(true);
					}}
				/>
			</ContentWrapper>
			{hook.show && (
				<AttachmentForm
					selectedFile={hook.selectedFile}
					reload={hook.loadPages}
					setShow={hook.setShow}
					languageOptions={hook.languageOptions}
				/>
			)}
			{!!hook.files?.length && (
				<AttachmentsTable
					loadingFiles={hook.loadingFiles}
					handleDownloadFile={hook.handleDownloadFile}
					setSelectedFile={hook.setSelectedFile}
					setShow={hook.setShow}
					files={hook.files}
				/>
			)}
		</PageWrapper>
	);
};

export default Attachments;
